import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/database'
import 'firebase/compat/analytics'
import 'firebase/compat/storage'
import {firebaseConfig} from '../config'

firebase.initializeApp(firebaseConfig);

const dbRef = firebase.database().ref();
const user = firebase.auth().currentUser;
const usersRef = dbRef.child("users");

export { firebase, dbRef, usersRef, user }
